import React from 'react'
import { clsx } from 'clsx'

export default function QuizProgress({ currentIndex, total, answeredCount, pointsLabel, tierLabel }) {
  const pct = total > 0 ? Math.round(((currentIndex + 1) / total) * 100) : 0
  return (
    <div className="space-y-2">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 text-sm text-neutral-400">
        <span>
          Question <span className="font-semibold text-white">{currentIndex + 1}</span> of {total}
          {pointsLabel ? (
            <>
              {' '}
              <span className="text-neutral-600">·</span>{' '}
              <span className="text-primary-400 font-medium">{pointsLabel}</span>
            </>
          ) : null}
          {tierLabel ? (
            <>
              {' '}
              <span className="text-neutral-600">·</span> <span className="text-neutral-500">{tierLabel}</span>
            </>
          ) : null}
        </span>
        <span>
          Answered: <span className="text-primary-400 font-medium">{answeredCount}</span> / {total}
        </span>
      </div>
      <div className="h-2 rounded-full bg-navy-800 overflow-hidden border border-neutral-800/80">
        <div
          className={clsx('h-full rounded-full bg-gradient-to-r from-primary-500 to-primary-600 transition-all duration-300')}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
